<template>
    <div id="detail-media" class="modal inmodal fade mediapool-detail" role="dialog" aria-hidden="true"
         data-backdrop="static" tabindex="-1">
        <div class="modal-dialog modal-xl">
            <div class="modal-content animated fadeInUp">
                <div class="modal-header-dialog-painting">
                    <button type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true"><i class="fa-regular fa-xmark"></i></span>
                        <span class="sr-only">{{ t_close }}</span>
                    </button>
                    <h2 v-if="mediaTitle" class="modal-title">{{ mediaTitle }}</h2>
                </div>
                <div class="modal-body text-center scrollBox d-flex align-center justify-center" :style="'height: ' + 80 + 'vh;'">
                    <video v-if="mediaType === 'video'" controls autoplay loop :height="videoHeight">
                        <source :src="mediaUrl" :type="mediaMime">
                    </video>
                    <img alt="media" v-if="mediaType === 'image'" :src="mediaUrl"/>
                    <pre v-if="mediaType === 'other'" style="text-align: left;">{{ mediaUrl }}</pre>
                    <embed v-if="mediaType === 'pdf'" :src="mediaUrl" type="application/pdf" width="100%"/>
                    <div :style="{height: frame.height + 'px'}">
                    <iframe v-if="mediaType === 'html'"
                        :style="[iframeStyles]"
                        :src="mediaUrl"
                        sandbox="allow-scripts allow-same-origin">
                    </iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import modalMixin from "../../common/modal-mixin";

    export default {
        mixins: [
            modalMixin,
        ],
        data: function () {
            return {
                t_close: Lang.langGet("Close"),
                mediaType: '',
                mediaUrl: '',
                mediaMime: '',
                mediaTitle: 'Title',
                frame: {},

                modalName: 'detail-media',
            }
        },
        methods: {
            reset: function () {
                _.extend(this.$data, this.$options.data());
            }
        },
        computed: {
            iframeStyles: function () {
                return {
                    // 1000.0: FIXED width of modal content
                    width: this.frame.width / this.frame.ratio + 'px',
                    height: this.frame.height / this.frame.ratio + 'px',
                    '-webkit-transform': 'scale(' + this.frame.ratio + ')',
                    '-webkit-transform-origin': '0 0',
                    'z-index': -1,
                    border: 0,
                }
            },
            videoHeight() {
                return window.innerHeight * 0.6;
            }
        },
        updated() {
            if(this.$el && this.visible && this.$el.parentNode) {
                this.$el.parentNode.removeChild(this.$el);
                document.getElementById('wrapper-content').appendChild(this.$el);
            }
        },
        mounted() {
            EaseEventBus.listen('showMedia', (media) => {
                this.reset();

                this.mediaMime = media.mime_type;
                this.mediaUrl = media.original || media.preview;
                this.mediaTitle = media.display_name;

                if (Laravel.allowedImageFileTypes.indexOf(media.mime_type) !== -1) {
                    this.mediaType = 'image';
                } else if (Laravel.allowedVideoFileTypes.indexOf(media.mime_type) !== -1) {
                    this.mediaType = 'video';
                } else if (Laravel.allowedPDFFileTypes.indexOf(media.mime_type) !== -1) {
                    this.mediaType = 'pdf';
                } else if (Laravel.allowedPPTFileTypes.indexOf(media.mime_type) !== -1) {
                    window.location = this.mediaUrl;
                    return;
                } else if (media.mime_type === 'text/html') {
                    this.frame = media.previewFrame;

                    // 1000.0: FIXED width of modal content
                    let modalContentWidth = 1000.0-60-6;
                    this.frame.ratio = this.frame.width / this.frame.ratio;
                    this.frame.height = (modalContentWidth / this.frame.width * this.frame.height);
                    this.frame.width = modalContentWidth;
                    this.frame.ratio = this.frame.width / this.frame.ratio;

                    this.mediaType = 'html';
                } else if (Laravel.allowedOtherFileTypes.indexOf(media.mime_type) !== -1) {
                    this.mediaType = 'other';
                }

                if(media.file_name !== 'dummy_placeholder') {
                    EaseEventBus.fire('showModal', this.modalName);
                }
            });

            EaseEventBus.listen('hideModal', (modal) => {
                if (modal === this.modalName) {
                    this.reset();
                }
            });
        }
    }
</script>
